/*jshint esversion: 8 */
import React, { Component } from 'react';

import { observer } from "mobx-react";
import MessageDialog from './templates/MessageDialog';

import store from '../components/stores/Store';
import { signinWithToken } from '../db/SystemOperationRequestHandler';

import { clearLocalStorage, getLocalStorageFieldWithFieldName } from '../utils/LocalStorageHandler';

import { hostName } from '../config/ips';

class StartInner extends Component {
  constructor() {
    super();
    this.state = {};
    this.loginWithToken = this.loginWithToken.bind(this);
  }

  async componentDidMount() {
    const token = getLocalStorageFieldWithFieldName('token');
    const marketId = getLocalStorageFieldWithFieldName('marketId');
    store.setMarketId(marketId);
    console.log(`----- componentDidMount-token: `, token);
    if (!store.user.logined && token) {
      this.loginWithToken(token);
    }
  }
  componentWillUnmount() {
    this.setState({
      count: {
        submit: '',
        selling: '',
        sold: '',
      },
    });
  }

  async loginWithToken(token) { // localStorage登陆
    console.log(`----- signinWithToken`);
    store.userSignin({ token: token });
    const rst = await signinWithToken(token);
    if (rst.code === 'error') {
      clearLocalStorage();
      console.log(`----- 使用缓存登陆失败`);
      store.openMessageDialogOpen(rst.msg || '使用缓存登陆失败');
      return true;
    } else if (rst.code === 'success') {
      store.userSignin({
        token: token,
        uuid: rst.uuid,
        marketId: rst.marketId,
        memname: rst.memname,
        rolename: rst.rolename,
        authSettings: rst.rolePrivilege,
        phone: rst.phone || '',
      });
    }
  }

  render() {
    return (
      <div>
        <MessageDialog />
      </div>
    );
  }
}

const Start = observer(StartInner);

export default Start;
